



























































import Vue from 'vue';

import AuditorInput from '@/vue/components/input/Auditor.vue';

interface Auditor {
  id: string;
  name: string;
}

export default Vue.extend({
  components: {
    'input-auditor': AuditorInput,
  },

  props: {
    data: Object as () => Auditor | null,
    taskId: String as () => string,
  },

  data() {
    return {
      userId: null as string | null,
      visible: false,
    };
  },

  methods: {
    handleDismiss() {
      this.visible = false;
      this.userId = this.data ? this.data.id : null;
    },

    handleOk() {
      this.visible = false;
      this.$emit('submit', { taskId: this.taskId, userId: this.userId });
    },

    showModal() {
      this.visible = true;
    },
  },
});
